//Labels for Login Page
export const PLACEHOLDER_EMAIL = 'Enter the email address';
export const PLACEHOLDER_PASSWORD = 'Enter the password';
export const LABEL_NEW_PASSWORD = 'New Password';
export const PLACEHOLDER_NEW_PASSWORD = 'Enter the new password';
export const LABEL_CONFIRM_PASSWORD = 'Confirm Password';
export const PLACEHOLDER_CONFIRM_PASSWORD = 'Confirm the new password';
export const LABEL_REMEMBER_ME = 'Remember me';
export const LABEL_FORGOT_PASSWORD = 'Forgot password?';
export const BTN_LOGIN = 'Login';
export const ERR_INVALID_CREDENTIALS = 'Invalid Email or Password';
export const COPYWRIGHT_TEXT = `© ${new Date().getFullYear()} HealthLink Dimensions. All rights reserved.`;

//Labels for Provider search Page
export const BTN_EXPORT = 'Export';

//Error Messages for Email and Password (Login/Forgot Password/Reset Password)
export const ERR_EMAIL_INVALID = 'Please enter a valid email address';
export const ERR_EMAIL = 'Please enter a valid email address';
export const ERR_PASSWORD_REQUIRED = 'Please enter the password';
export const ERR_PASSWORD_8_CHAR = 'Password must be 8 characters long';
export const ERR_PASSWORD_NUMBER = 'Password requires a number';
export const ERR_PASSWORD_UPPERCASE = 'Password requires an uppercase letter';
export const ERR_PASSWORD_LOWERCASE = 'Password requires a lowercase letter';
export const ERR_PASSWORD_SPECIAL_CHAR = 'Password requires a symbol';

//Labels for Forgot Password page
export const FORGOT_PASSWORD_TITLE = 'Forgot your password?';
export const LABEL_HEADER_NOTE =
  'Enter your email address and we will send you the recovery link to reset your password';
export const LABEL_RETURN_LOGIN = 'Return to login';
export const BTN_SEND_LINK = 'Send Recovery Link';
export const ERR_INVALID_EMAIL = 'Please enter a valid email address';
export const ERR_UNKOWN_API_RESPONSE =
  'An unknown error has occurred. Please contact support.';

//Labels for Forgot Password Success page
export const FORGOT_PASSWORD_SUCCESS_TITLE = 'Check your email';
export const LABEL_HEADER =
  'Please check the email address for the instructions to reset your password';
export const LABEL_CLICK_TO_RESEND = 'Resend email';
export const FORGOT_PASSWORD_MESSAGE_1 = 'Please check the email address';
export const FORGOT_PASSWORD_MESSAGE_2 =
  'for instructions to reset your password';

//Footer links
export const FOOTER_LINK_1 = 'Terms of use';
export const FOOTER_LINK_2 = 'Privacy Policy';
export const FOOTER_LINK_3 = 'Legal';

// Labels for Reset password
export const RESET_PASSWORD_TITLE = 'Change your password';
export const CREATE_PASSWORD_TITLE = 'Create your password';
export const RESET_PASSWORD_MESSAGE =
  'Enter a new password below to change your password';
export const CREATE_PASSWORD_MESSAGE = 'Enter a new password below to login';
export const RESET_PASSWORD_BTN = 'Reset Password';
export const CREATE_PASSWORD_BTN = 'Create Password';
export const RESET_PASSWORD_VERIFY_TOKEN =
  'The password reset link has expired. Please request a new one to reset your password.';
export const RESET_PASSWORD_PASSWORD_MESSAGE = 'Please enter your password';
export const RESET_PASSWORD_CONFIRM_PASSWORD_MESSAGE =
  'Please re-enter your password';
export const RESET_PASSWORD_MATCH = 'Password match';
export const RESET_PASSWORD_DOESNOTMATCH = 'Password do not match';
export const ERR_NEW_PASSWORD_MESSAGE = 'Please enter the password';
export const ERR_CONFIRM_PASSWORD_MESSAGE = 'Please confirm the password';

//Labels for Reset password success
export const RESET_PASSWORD_SUCCESS_TITLE = 'Password Changed';
export const RESET_PASSWORD_SUCCESS_MESSAGE =
  'Your password has been changed successfully';
export const RESET_PASSWORD_SUCCESS_BTN = 'Return to login';

//Labels for new user page
export const NEW_USER_FIRST_NAME = 'First name*';
export const NEW_USER_LAST_NAME = 'Last name*';
export const NEW_USER_EMAIL_ADDRESS = 'Email address*';
export const NEW_USER_PHONE = 'Phone';
export const NEW_USER_COMPANY = 'Company*';
export const NEW_USER_TITLE = 'Title';
export const NEW_USER_TIME_ZONE = 'Time zone*';
export const NEW_USER_ROLES = 'Roles';
export const NEW_USER_ERROR_FIRST_NAME = 'Please enter the first name';
export const NEW_USER_ERROR_INVALID_FIRST_NAME =
  'Please enter valid first name';
export const NEW_USER_ERROR_LAST_NAME = 'Please enter the last name';
export const NEW_USER_ERROR_INVALID_LAST_NAME = 'Please enter valid last name';
export const NEW_USER_ERROR_EMAIL_ADDRESS = 'Please enter the email address';
export const NEW_USER_ERROR_COMPANY = 'Please select the company';
export const NEW_USER_ERROR_TIME_ZONE = 'Please select the time zone';
export const NEW_USER_ERROR_TITLE = 'Please enter the title';
export const NEW_USER_SUCCESS_MESSAGE = 'User created successfully';
export const NEW_USER_PASSWORD_SUCCESS_MESSAGE =
  'Password created successfully';

//Labels for update user page
export const UPDATE_USER_FIRST_NAME = 'First name*';
export const UPDATE_USER_LAST_NAME = 'Last name*';
export const UPDATE_USER_EMAIL_ADDRESS = 'Email address*';
export const UPDATE_USER_PHONE = 'Phone';
export const UPDATE_USER_COMPANY = 'Company*';
export const UPDATE_USER_TITLE = 'Title';
export const UPDATE_USER_TIME_ZONE = 'Time zone*';
export const UPDATE_USER_ROLES = 'Roles';
export const UPDATE_USER_ERROR_FIRST_NAME = 'Please enter the first name';
export const UPDATE_USER_ERROR_LAST_NAME = 'Please enter the last name';
export const UPDATE_USER_ERROR_EMAIL_ADDRESS = 'Please enter the email address';
export const UPDATE_USER_ERROR_COMPANY = 'Please select the company';
export const UPDATE_USER_ERROR_TIME_ZONE = 'Please select the time zone';
export const UPDATE_USER_SUCCESS_MESSAGE = 'User updated successfully';
export const UPDATE_USER_DELETE_USER_SUCCESS_MESSAGE =
  'User deleted successfully';
export const UPDATE_USER_DELETE_USER_ERROR_MESSAGE = 'Something went wrong';
export const UPDATE_USER_DELETE_SUBTITLE_1 = 'Are you sure you want to delete';
export const UPDATE_USER_DELETE_SUBTITLE_2 = 'user profile?';
export const UPDATE_USER_LOGIN_SUBTITLE_1 = 'Are you sure you want to login as';
export const UPDATE_USER_LOGIN_SUBTITLE_2 = '?';
export const UPDATE_USER_LOGIN_SWITCH_BACK =
  'Are you sure you want to switch back to';
export const UPDATE_USER_DEACTIVATE_SUBTITLE_1 = 'Are you sure you want to deactivate';
export const UPDATE_USER_DEACTIVATE_SUBTITLE_2 = 'user profile?';
export const UPDATE_USER_ACTIVATE_SUBTITLE_1 =
  'Are you sure you want to activate';
export const UPDATE_USER_ACTIVATE_SUBTITLE_2 = 'user profile?';
export const LOGIN_AS_USER = 'Login as user';

export const UPDATE_ROLE_ACTIVE_DEACTIVATE_SUBTITLE_1 =
  'Are you sure you want to  ';
export const USER_DEACTIVATE_MESSAGE = "Deactivate this user";
export const USER_ACTIVATE_MESSAGE = "Activate this user";
export const USER_DELETE_MESSAGE = "Delete this user from the application database";

//Labels for update role page
export const UPDATE_ROLE_ERROR_ROLE_NAME = 'Please enter the role';
export const NEW_ROLE_ERROR_INVALID_ROLE_NAME = 'Please enter valid role';
export const UPDATE_ROLE_NAME_LABEL = 'Role Name*';
export const UPDATE_ROLE_NAME = 'Role name*';
export const UPDATE_ROLE_DESC_LABEL = 'Role Description';
export const UPDATE_ROLE_DESC = 'Role description';
export const UPDATE_ROLE_SUCCESS_MESSAGE = 'Role updated successfully';
export const UPDATE_ROLE_DELETE_ROLE_SUCCESS_MESSAGE =
  'Role deleted successfully';
export const UPDATE_ROLE_ACTIVATE_ROLE_SUCCESS_MESSAGE =
  'Role activated successfully';
export const UPDATE_ROLE_DEACTIVATE_ROLE_SUCCESS_MESSAGE =
  'Role deactivated successfully';
export const UPDATE_ROLE_DELETE_ROLE_ERROR_MESSAGE = 'Something went wrong';
export const UPDATE_ROLE_DELETE_SUBTITLE_2 = 'role?';
export const LABEL_ROLE_INFORMATION = 'Role Information';
export const UPDATE_ROLE_PERMISSION_ROLE_SUCCESS_MESSAGE =
  'Permission added to the role successfully';
export const UPDATE_ROLE_USERS_ROLE_SUCCESS_MESSAGE =
  'Users added to the role successfully';

//Labels for new role page
export const NEW_ROLE_NAME = 'Role name*';
export const NEW_ROLE_DESC = 'Description';
export const NEW_ROLE_SUCCESS_MESSAGE = 'Role created successfully';
export const ENTER_NEW_ROLE_LABEL = 'Role Name';
export const ENTER_NEW_ROLE = 'Enter role name';
export const ENTER_NEW_DESCRIPTION_LABEL = 'Role Description';
export const ENTER_NEW_DESCRIPTION = 'Enter role description';

// Organization Verification Page
export const LABEL_ORGANIZATION_HEADING =
  'Online Directory Validation Guidelines';
export const LABEL_ORGANIZATION_VERIFICATION = 'Organization Verification';
export const LABEL_BTN_BACK_TO_QUEUE = 'Back to Queue';
export const LABEL_TAX_ID = 'Tax ID';
export const LABEL_NUMBER_OF_LOCATIONS = '# of Locations';
export const LABEL_NUMBER_OF_PROVIDERS = '# of Providers';
export const LABEL_TO_BE_VERIFIED = 'To be verified';
export const LABEL_VERIFIED = 'Verified';
export const LABEL_REMOVED = 'Removed';
export const LABEL_PROVIDER_AT_THIS_LOCATION = 'Providers at this location';
export const LABEL_TITLE = 'Title';
export const LABEL_TAXANOMY = 'Taxonomy';
export const LABEL_LANGUAGE = 'Languages';
export const LABEL_PRIMARY_TAXANOMY = 'Primary Taxonomy';
export const LABEL_SPECIALITY = 'Speciality';
export const LABEL_PRIMARY_SPECIALITY = 'Primary Speciality';
export const LABEL_ACCEPTING_NEW_PATIENTS = 'Accepting New Patients';
export const LABEL_ACTING_AS_PCP = 'Acting as PCP';
export const LABEL_TELEHEALTH = 'Telehealth';
export const LABEL_BTN_ADD_LOCATION = 'Add Location';
export const LABEL_BTN_ADD_PROVIDER = 'Add Provider';
export const LABEL_BTN_BACK = 'Back';
export const LABEL_BTN_NEXT_LOCATION = 'Next Location';
export const LABEL_REMOVE_LOCATION = 'Remove Location';
export const LABEL_REMOVE_PROVIDER = 'Remove Provider';
export const LABEL_ID = 'ID';
export const LABEL_BTN_LOOKS_GOOD = 'Looks Good';
export const LABEL_BTN_UPDATE = 'Update';
export const LABEL_NPI = 'NPI';
export const LABEL_ADD_PROVIDER = 'Add Provider';
export const LABEL_UPDATE_PROVIDER = 'Update Provider';
export const LABEL_CALL_STATUS_DETAIL = 'Call status detail';

// Add / Update / Delete Location
export const PLACEHOLDER_ENTER_LOCATION_NAME = 'Location name*';
export const ERR_LOCATION_NAME_REQUIRED = 'Please enter location name';
export const ERR_INVALID_LOCATION_NAME = 'Please enter a valid location name';
export const LABEL_LOCATION_INFORMATION = 'Location Information';
export const LABEL_ADDRESS_LINE1 = 'Address line 1*';
export const LABEL_ADDRESS_LINE2 = 'Address line 2';
export const LABEL_CITY = 'City*';
export const LABEL_STATE = 'State*';
export const LABEL_ZIP = 'Zip*';
export const LABEL_COUNTY = 'County';
export const LABEL_FAX = 'Fax';
export const LABEL_Phone = 'Phone *';
export const LABEL_DIGITAL_CONTACT = 'Email for patient (Digital  contact)';
export const LABEL_WEBSITE = 'Website';
export const LABEL_CONTACT_INFORMATION = 'Contact Information';
export const LABEL_ADMIN_NAME = 'Admin name';
export const LABEL_ADMIN_EMAIL = 'Admin email';
export const LABEL_VERIFICATION_SOURCE = 'Verification Source';
export const LABEL_VERIFICATION_TYPE = 'Verification type';
export const LABEL_VERIFICATION_PERSON_NAME = 'Verified person name';
export const LABEL_VERIFICATION_PERSON_PHONE = 'Verified person phone';
export const LABEL_VERIFICATION_PERSON_EMAIL = 'Verified person email';
export const LABEL_VERIFIED_SOURCE_URL = 'Verified source URL';
export const LABEL_ADD_COMMENT = 'Add Comment';
export const ERR_ADDRESS_LINE1_REQUIRED = 'Please enter address line 1';
export const ERR_ADDRESS_LINE1_VALID = 'Please enter a valid address line 1';
export const ERR_ADDRESS_LINE2_REQUIRED = 'Please enter address line 2';
export const ERR_ADDRESS_LINE2_VALID = 'Please enter a valid address line 2';
export const ERR_CITY_REQUIRED = 'Please enter city';
export const ERR_CITY_VALID = 'Please enter a valid city';
export const ERR_COUNTRY_REQUIRED = 'Please enter country';
export const ERR_STATE_REQUIRED = 'Please enter state';
export const ERR_STATE_VALID = 'Please enter a valid state';
export const ERR_PHONE_REQUIRED = 'Please enter phone';
export const ERR_ZIP_REQUIRED = 'Please enter zip';
export const LABEL_LAST_VERIFICATION_TYPE = 'Last Verification Type';
export const LABEL_LAST_VERIFIED = 'Last Verified';
export const LABEL_COMMENTS = 'Comments';
export const LABEL_HISTORY = 'History';
export const LABEL_ADDRESS = 'Address';
export const LABEL_PHONE = 'Phone';
export const LABEL_UNABLE_TO_VERIFY = 'Unable to verify';
export const LABEL_REASON_FOR_UNABLE_TO_VERIFY =
  'Reason for unable to verify *';
export const LABEL_REASON_FOR_REMOVAL = 'Reason for removal*';
export const LABEL_EFFECTIVE_DATE = 'Effective date*';
export const LABEL_REMOVE_LOCATION_WARNING_MESSAGE_1 =
  'Warning: This action cannot be undone';
export const LABEL_REMOVE_LOCATION_WARNING_MESSAGE_2 =
  'Are you sure you want to delete';
export const LABEL_REMOVE_LOCATION_WARNING_MESSAGE_3 =
  'Removing location will also remove all associated providers from the location';
export const LABEL_BTN_REMOVE_LOCATION = 'Remove Location';
export const MESSAGE_SUCCESS_ADD_LOCATION = 'Location Added Successfully';
export const MESSAGE_SUCCESS_UPDATE_LOCATION =
  'Organization location updated successfully';
export const MESSAGE_SUCCESS_REMOVE_LOCATION =
  'Organization location removed successfully';
export const ERR_REASON_FOR_REMOVAL_REQUIRED =
  'Please select reason for removal';
export const ERR_EFFECTIVE_DATE_REQUIRED = 'Please enter effective date';
export const ERR_INVALID_ZIP = 'Invalid ZIP code';
export const ERR_INVALID_URL = 'Please enter a valid URL';
export const ERR_ADMIN_NAME_REQUIRED = 'Please enter admin name';
export const ERR_ADMIN_EMAIL_REQUIRED = 'Please enter admin email address';
export const ERR_VERIFIED_PERSON_NAME_REQUIRED =
  'Please enter verified person name';
export const ERR_VERIFIED_PERSON_PHONE_REQUIRED =
  'Please enter verified phone number';
export const ERR_VERIFIED_PERSON_EMAIL_REQUIRED = 'Please enter verified email';
export const ERR_VERIFIED_SOURCE_URL_REQUIRED =
  'Please enter verified source URL';
export const ERR_INVALID_PHONE = 'Please enter valid phone number';
export const ERR_INVALIE_FAX = 'Please enter valid fax number';
export const ERR_INVALID_DATE = 'Please enter valid date';
export const ERR_MIN_DATE_VALIDATION =
  'Effective date must be after 01/01/2000';
export const ERR_MAX_DATE_VALIDATION =
  'Effective date must be before 12/31/2050';
export const ERR_REASON_FOR_UNABLE_TO_VERIFY = 'Please enter the reason';

export const LABEL_BTN_CANCEL = 'Cancel';
export const LABEL_BTN_SAVE = 'Save';

export const UNKNOWN_ERR = 'Unknown error has occurred';
export const ERR_INVALID_VARIFICATION_ID =
  'The verification type ID is not valid';

export const LABEL_PLEASE_SELECT = 'Please Select';

// Labels for organization admin login page
export const ORG_ADMIN_TITLE = 'Cancer Center Northwest';
export const ORG_ADMIN_FIRST_NAME = 'First name';
export const ORG_ADMIN_LAST_NAME = 'Last name';
export const ORG_ADMIN_EMAIL = 'Email address';
export const ORG_ADMIN_TIN = 'TIN Number';
export const ORG_ADMIN_TIN_NEW = 'TIN - Last 4 digits';
export const ORG_ADMIN_PLACEHOLDER_FIRST_NAME = 'Enter the first name';
export const ORG_ADMIN_PLACEHOLDER_LAST_NAME = 'Enter the last name';
export const ORG_ADMIN_PLACEHOLDER_EMAIL = 'Enter the email address';
export const ORG_ADMIN_PLACEHOLDER_TIN = 'Last 4 digits of Tax ID Number (TIN)';
export const ORG_ADMIN_ERR_FIRST_NAME = 'Please enter the first name';
export const ORG_ADMIN_ERR_LAST_NAME = 'Please enter the last name';
export const ORG_ADMIN_ERR_EMAIL = 'Please enter the email address';
export const ORG_ADMIN_ERR_TIN =
  'Please enter the last 4 digits of Tax ID Number (TIN)';
export const ORG_ADMIN_ERR_TIN_POSITIVE =
  'Please enter the positive TIN Number';
export const ORG_ADMIN_ERR_TERMS = 'Please agree to all terms and conditions';
export const ORG_ADMIN_ERR_ACKNOWLEDGE =
  'Please acknowledge that you are authorized to validate providers for your organization';
export const ORG_ADMIN_LOGIN_SUCCESS = 'Loggedin successfully';
export const ORG_ADMIN_LOGIN_ERROR =
  'Invalid credentials, please contact support for assistance';
export const ORG_ADMIN_TERMS =
  'Yes, I agree to the Online Directory Validation Guidelines';
export const ORG_ADMIN_ACKNOWLEDGE =
  'I have the authority to validate the providers at my organization and agree that the information I provide is the source of truth';

//Lavel for live out react queue page
export const LIVE_OUT_REACH_QUEUE_ASSIGN_ME_SUCCESS =
  'User assigned successfully';
export const LIVE_OUT_REACH_QUEUE_ASSIGN_ME_ERROR = 'Something went wrong';
export const LIVE_OUT_REACH_QUEUE_UNASSIGN_ME_SUCCESS =
  'User unassigned successfully';
export const LIVE_OUT_REACH_QUEUE_UNASSIGN_ME_ERROR = 'Something went wrong';

// Add / Update / Delete Provider
export const LABEL_PROVIDER_INFORMATION = 'Provider Information';
export const LABEL_PROVIDER_NAME = 'Provider name';
export const LABEL_FIRST_NAME = 'First name*';
export const LABEL_MIDDLE_NAME = 'Middle name';
export const LABEL_LAST_NAME = 'Last name*';
export const LABEL_SUFFIX = 'Suffix';
export const LABEL_PROVIDER_LOCATION = 'Provider location';
export const LABEL_PRIMARY_LOCATION = 'Primary location';
export const LABEL_LANGUAGES = 'Provider language(s)';
export const LABEL_GENDER = 'Gender';
export const LABEL_PROVIDER_ACTING_AS_PCP = 'Provider acting as PCP';
export const LABEL_TELEHEALTH_PROVIDER = 'Telehealth provider';
export const LABEL_PROVIDER_ADDED_SUCCESSFULLY =
  'Providers have been added successfully';
export const LABEL_BTN_REMOVE_PROVIDER = 'Remove Provider';
export const MESSAGE_SUCCESS_REMOVE_PROVIDER = 'Provider removed successfully';
export const MESSAGE_SUCCESS_UPDATE_PROVIDER = 'Provider updated successfully';
export const MESSAGE_VERIFIED_PROVIDER = 'Provider verified successfully';
export const ERR_ENTER_FIRST_NAME = 'Please enter first name';
export const ERR_ENTER_LAST_NAME = 'Please enter last name';
export const ERR_SELECT_PROVIDER = 'Please select providers';
export const ERR_ENTER_MIDDLE_NAME = 'Please enter middle name';
export const ERR_ENTER_SUFFIX_NAME = 'Please enter a valid suffix';

//Org Admin Verification
export const LABEL_THANK_YOU = 'Thank you!';
export const MESSAGE_THANK_YOU = 'We have successfully updated all information';
export const BTN_VERIFICATION_IN_PROGRESS = 'Verification in Progress';
export const BTN_SUBMIT = 'Submit';
export const LABEL_ENTER_ORG_NAME = 'Enter organization name';
export const LABEL_ORG_NAME_UNAVAILABLE = 'Organization name unavailable';
export const MESSAGE_ORG_NAME_UPDATED =
  'Organization name updated successfully';
export const ERR_ENTER_ORG_NAME = 'Please enter organization name';
export const ERR_VALID_ORG_NAME = 'Please enter a valid organization name';
export const LABEL_PENDING_PROVIDERS = 'Pending - Verify Providers';
export const LABEL_UNAVAILABLE = 'Unavailable';
export const LABEL_NOT_PRIMARY_LOCATION = 'Not Primary Location';
export const BTN_VERIFY_PROVIDER = 'Verify Providers >';
export const LABEL_UPDATE_LOCATION = 'Update Location';

export const LABEL_UPDATE_PERMISSION = 'Permissions';
export const LABEL_UPDATE_USERS = 'Users';
export const LABEL_BTN_CONFIRM = 'Confirm';
export const MESSAGE_ADDRESS_ALREADY_EXIST =
  'Address is already associated with location.';

//Org Admin Verification
export const LABEL_FIRST_PARAGRAPH =
  'Healthlink Dimensions works on behalf of medical and dental plans to verify accuracy of provider demographic data to ensure current online directory data. Completing validation ensures current information is available for member online searches. ';
export const LABEL_SECOND_PARAGRAPH =
  'Directory validation does not replace the requirement to notify health and dental plans directly with provider or office changes:';
export const LABEL_FIRST_POINT =
  'Directory validation supports CAA, state and federal compliance requirements';
export const LABEL_SECOND_POINT =
  'Organization (practice info, address, phone, fax, contact) as well as provider (location, telehealth, specialty) are all components verified through validation ';
export const LABEL_THIRD_POINT =
  'Ensure the administrator/provider/staff member is authorized to complete the validation';
export const LABEL_FOURTH_POINT =
  'Providers or offices failing to complete validation may be removed from the plans’ online directories until validation is completed';
export const LABEL_FIFTH_POINT = 'Validations are required every 90 days';
export const LABEL_SIXTH_POINT =
  'For questions about validation, email ProviderNSA@healthlinkdimensions.com';
export const LABEL_SEVENTH_POINT =
  'For claims or contract questions, please contact your health or dental payer directly';

//HLD Research and HLD Digital in Update Location and Update Provider
export const LABEL_HLD_DIGITAL = 'HLD Digital';
export const LABEL_HLD_RESEARCH = 'HLD Research';

//Webhook
export const ARE_YOU_SURE = 'Are you sure you want to ';
export const DELETE_WEBHOOK = 'delete the webhook ';
export const WEBHOOK_NAME = 'Enter webhook name';
export const WEBHOOK_URL = 'Enter webhook URL';
export const WEBHOOK_CLIENTID = 'Enter webhook client Id';
export const WEBHOOK_SECRET = 'Enter webhook secret key';
export const WEBHOOK_SECRET_VALUE = 'Enter webhook secret value';
export const UPDATE_WEBHOOK_SUCCESS_MESSAGE = 'Webhook updated successfully';
export const DELETE_WEBHOOK_SUCCESS_MESSAGE = 'Webhook deleted successfully';
export const ACTIVATE_WEBHOOK_SUCCESS_MESSAGE = 'Webhook activated successfully';
export const DEACTIVATE_WEBHOOK_SUCCESS_MESSAGE = 'Webhook deactivated successfully';
export const WEBHOOK_NAME_ERROR = 'Please enter the webbook name';
export const WEBHOOK_NAME_INVALID = 'Please enter valid webbook name';
export const WEBHOOK_SECRET_KEY_ERROR = 'Please enter the secret key';
export const WEBHOOK_SECRET_KEY_INVALID = 'Please enter valid secret key';
export const WEBHOOK_SECRET_VALUE_ERROR = 'Please enter the secret value';
export const WEBHOOK_SECRET_VALUE_INVALID = 'Secret Value must be a valid bearer token';
export const WEBHOOK_URL_LIMIT_MESSAGE = "You can add only one webhook URL at a time.";

//Brand
export const DELETE_BRAND = 'delete the brand ';
export const BRAND_NAME = 'Enter brand name';
export const BRAND_DESC = 'Enter brand description';
export const BRAND_CLIENTID = 'Enter brand client Id';
export const UPDATE_BRAND_SUCCESS_MESSAGE = 'Brand updated successfully';
export const DELETE_BRAND_SUCCESS_MESSAGE = 'Brand deleted successfully';
export const ACTIVATE_BRAND_SUCCESS_MESSAGE = 'Brand activated successfully';
export const DEACTIVATE_BRAND_SUCCESS_MESSAGE = 'Brand deactivated successfully';
export const BRAND_NAME_ERROR = 'Please enter the brand name';
export const BRAND_NAME_INVALID = 'Please enter valid brand name';
export const BRAND_DESC_ERROR = 'Please enter the brand description';
export const BRAND_DESC_INVALID = 'Please enter valid brand description';
export const BRAND_DELETE_INVALID = 'This brand is currently being used in an active campaign and cannot be deleted.';

//Group
export const DELETE_GROUP = 'delete the group ';
export const GROUP_NAME = 'Enter group name';
export const GROUP_DESC = 'Enter group description';
export const GROUP_CLIENTID = 'Enter group client Id';
export const UPDATE_GROUP_SUCCESS_MESSAGE = 'Group updated successfully';
export const DELETE_GROUP_SUCCESS_MESSAGE = 'Group deleted successfully';
export const ACTIVATE_GROUP_SUCCESS_MESSAGE = 'Group activated successfully';
export const DEACTIVATE_GROUP_SUCCESS_MESSAGE = 'Group deactivated successfully';
export const GROUP_NAME_ERROR = 'Please enter the group name';
export const GROUP_NAME_INVALID = 'Please enter valid group name';
export const GROUP_DESC_ERROR = 'Please enter the group description';
export const GROUP_DESC_INVALID = 'Please enter valid group description';
export const GROUP_DELETE_INVALID = 'This group is currently being used in an active campaign and cannot be deleted.';

//Api
export const DELETE_API = 'delete the API Key';
export const API_NAME = 'Enter api name';
export const API_TOKEN = 'Enter api access token';
export const API_CLIENTID = 'Enter api client Id';
export const API_SECRET = 'Enter api secret key';
export const API_SECRET_VALUE = 'Enter api secret value';
export const UPDATE_API_SUCCESS_MESSAGE = 'API Key updated successfully';
export const DELETE_API_SUCCESS_MESSAGE = 'API Key deleted successfully';
export const ACTIVATE_API_SUCCESS_MESSAGE = 'API Key activated successfully';
export const DEACTIVATE_API_SUCCESS_MESSAGE = 'API Key deactivated successfully';
export const API_NAME_ERROR = 'Please enter the api name';
export const API_NAME_INVALID = 'Please enter valid api name';
export const API_SECRET_KEY_ERROR = 'Please enter the secret key';
export const API_SECRET_KEY_INVALID = 'Please enter valid secret key';
export const API_SECRET_VALUE_ERROR = 'Please enter the secret value';
export const API_SECRET_VALUE_INVALID = 'Secret Value must be valid';

//Client
export const ERR_CLIENT_NAME_REQUIRED = "Please enter the client name"
export const ERR_CLIENT_CONTACT_REQUIRED = "Please enter the client contact"
export const ERR_SUB_CLIENT_NAME_REQUIRED = "Please enter the sub-client name"
export const ERR_SUB_CLIENT_CONTACT_REQUIRED = "Please enter the sub-client contact"
export const UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1 = "Are you sure you want to deactivate"
export const UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2 = "client?"
export const UPDATE_CLIENT_ACTIVATE_SUBTITLE_1 = "Are you sure you want to activate"
export const ERR_ESPCONNECTION_REQUIRED = "Please select ESP connection"

//Template
export const DELETE_TEMPLATE = 'delete the template ';
export const COPY_TEMPLATE = 'duplicate the template ';
export const TEMPLATE_NAME = 'Enter the template name';
export const TEMPLATE_FROM_NAME = 'Enter the from name';
export const TEMPLATE_FROM_EMAIL = 'Enter the from email';
export const TEMPLATE_REPLY_TO_EMAIL = 'Enter the reply-to email';
export const TEMPLATE__SUBJECT_LINE = 'Enter the subject line';
export const TEMPLATE_PREHEADER = 'Enter the preheader';
export const ADD_TEMPLATE_SUCCESS_MESSAGE = 'Template added successfully';
export const UPDATE_TEMPLATE_SUCCESS_MESSAGE = 'Template updated successfully';
export const DELETE_TEMPLATE_SUCCESS_MESSAGE = 'Template deleted successfully';
export const COPY_TEMPLATE_SUCCESS_MESSAGE = 'Template duplicated successfully';
export const ACTIVATE_TEMPLATE_SUCCESS_MESSAGE = 'Template approved successfully';
export const DEACTIVATE_TEMPLATE_SUCCESS_MESSAGE = 'Template rejected successfully';
export const TEMPLATE_NAME_ERROR = 'Please enter the template name';
export const TEMPLATE_FROM_NAME_ERROR = 'Please enter the from name';
export const TEMPLATE_SUBJECT_LINE_ERROR = 'Please enter the subject line';
export const TEMPLATE_PREHEADER_ERROR = 'Please enter the preheader';
export const TEMPLATE_NAME_INVALID = 'Please enter a valid template name';
export const TEMPLATE_FROM_NAME_INVALID = 'Please enter a valid from name';
export const TEMPLATE_DELETE_INVALID = 'Cannot delete an approved template';
export const TEMPLATE_PREHEADER_RESEND_MESSAGE ="If the recipient doesn't open the original email, the platform will resend it after the specified interval using the resend subject line and preheader."
export const TEMPLATE_RESEND_SUBJECT_LINE_MESSAGE = "Remove the resend subject line and preheader.";
export const TEMPLATE_EDITING_DISABLED_MESSAGE = "Editing is disabled for active or approved templates.";
export const SAVE_TEMPLATE = 'Save';
export const CANCEL_TEMPLATE = 'Cancel';
export const EDIT_TEMPLATE = 'Edit';
export const TEMPLATE_IN_USE_MESSAGE = 'Template is already in use';
export const VERSION_UPDATE = 'update the template version to version';
export const UPDATE_TEMPLATE_VERSION_SUCCESS_MESSAGE = 'Template version updated successfully';
//Campaign
export const DELETE_CAMPAIGN = 'delete the campaign ';
export const COPY_CAMPAIGN = 'duplicate the campaign ';
export const UPDATE_CAMPAIGN_SUCCESS_MESSAGE = 'Trigger email updated successfully';
export const DELETE_CAMPAIGN_SUCCESS_MESSAGE = 'Trigger email deleted successfully';
export const COPY_CAMPGAIN_SUCCESS_MESSAGE = 'Trigger email duplicated successfully';
export const ACTIVATE_CAMPAIGN_SUCCESS_MESSAGE = 'Trigger email activated successfully';
export const DEACTIVATE_CAMPAIGN_SUCCESS_MESSAGE = 'Trigger email deactivated successfully';
export const COPY_CAMPAIGN_SUCCESS_MESSAGE = 'Trigger email duplicated successfully';
export const ACTIVATE_TEST_MODE = 'activate test mode for the campaign  ';
export const DEACTIVATE_TEST_MODE = 'deactivate test mode for the campaign  ';
export const CAMPAIGN_IN_USE_MESSAGE = 'Campaign is already in use';
export const CAMPAIGN_START_DATE_PASSED_MESSAGE = 'Campaign start date has passed';

//Tooltips for Campaing Forms
export const CAMPAIGN_NAME_TOOLTIP = 'Enter campaign name';
export const BRAND_TOOLTIP = 'Select brand';
export const GROUP_TOOLTIP = 'Select group';
export const MAXIMUM_RESEND_TOOLTIP = 'Enter Maximum Resends';
export const RESEND_INTERVAL_TOOLTIP = 'Enter Resends Interval';
export const COOLDOWN_PERIOD_TOOLTIP = "Enter Cooldown Period"
export const CAMPAIGN_NAME_TOOLTIP_MESSAGE = "An internal name used to identify the campaign.";
export const BRAND_TOOLTIP_MESSAGE = "Used to organize campaigns by agency or partner.";
export const GROUP_TOOLTIP_MESSAGE ="Used to prevent multiple emails in the same group from being sent within the cooldown period.";
export const MAXIMUM_RESEND_TOOLTIP_MESSAGE ="Maximum number of times an email can be resent if unopened."
export const RESEND_INTERVAL_TOOLTIP_MESSAGE ="Days between each resend"
export const COOLDOWN_PERIOD_TOOLTIP_MESSAGE = "All subsequent triggers for the given NPI will be suppressed during the cooldown period.";
export const CAMPAIGN_EDITING_DISABLED_MESSAGE = "Editing is disabled for active or started campaigns";
export const API_REQUEST_FORMAT_MESSAGE = "This is a sample request format used for API calls.";

//List Trigger
export const DELETE_TRIGGER = 'delete the trigger ';
export const COPY_TRIGGER = 'duplicate the trigger ';
export const UPDATE_TRIGGER_SUCCESS_MESSAGE = 'Trigger updated successfully';
export const DELETE_TRIGGER_SUCCESS_MESSAGE = 'Trigger deleted successfully';
export const COPY_TRIGGER_SUCCESS_MESSAGE = 'Trigger duplicated successfully';
export const ACTIVATE_TRIGGER_SUCCESS_MESSAGE = 'Trigger activated successfully';
export const DEACTIVATE_TRIGGER_SUCCESS_MESSAGE = 'Trigger deactivated successfully';
export const TRIGGER_NAME = 'Enter the trigger Name';
export const CAMPAIGN_START_DATE = 'Campaign Start Date';
export const CAMPAIGN_END_DATE = 'Campaign End Date';
export const BRANDNAME = 'Brand';
export const CAMPAIGN_Group = 'Campaign Group';
export const EMAIL_TEMPLATE = 'Email Template';
export const LIST_TRIGGERNAME = 'List Trigger Name';
export const CAMPAIGN_NAME = 'Campaign Name';
export const SCHEDULED_START_DATE = 'Scheduled Start Date';
export const SCHEDULED_END_DATE = 'Scheduled End Date'; 
export const TOTALNPI = 'Total NPI';
export const TRIGGERSUCCESS  ='List Trigger Scheduled Successfully';
export const TRIGGER_NAME_ERROR = 'Please enter the list trigger name';
export const VALID_TRIGGER_NAME_ERROR = 'Please enter valid list trigger name';
export const TRIGGER_CAMPAIGN_ERROR = 'Please enter the campaign';
export const TRIGGER_STARTDATE_ERROR = 'Please enter the start date';
export const TRIGGER_CREATE_SUCCESS_MESSAGE = 'Trigger created successfully';
export const RESUME_TRIGGER_SUCCESS_MESSAGE = 'Trigger resume successfully';
export const PAUSE_TRIGGER_SUCCESS_MESSAGE = 'Trigger pause successfully';
export const TRIGGER_UPDATE_SUCCESS_MESSAGE = 'Trigger updated successfully';
export const TRIGGER_ALREADY_STARTED_MESSAGE = 'The list trigger has already started and is not paused..';

//SendTestEmail
export const SEND_TEST_EMAIL = 'Send Test Email';
export const SEND_EMAIL_SUCCESS ='Test emails sent successfully';
export const SEND_EMAIL_ERROR ='Error while sending emails';

//ESP Settings
export const UPDATE_ESP_SUCCESS_MESSAGE = 'ESP updated successfully';
export const DELETE_ESP_SUCCESS_MESSAGE = 'ESP deleted successfully';
export const ACTIVATE_ESP_SUCCESS_MESSAGE = 'ESP activated successfully';
export const DEACTIVATE_ESP_SUCCESS_MESSAGE = 'ESP deactivated successfully';
export const ESP_DOMAIN_NAME_ERROR = 'Please enter the domain name';
export const ESP_CONNECTION_NAME_INVALID = 'Please enter valid connection name';
export const UPDATE_ESP_DEACTIVATE_SUBTITLE_2 = "ESP?"
export const ERR_CONNECTION_NAME_REQUIRED = "Please enter the connection name"

//Seed List
export const DELETE_SEED_LIST = 'delete the seed list ';

//Suppression List
export const DELETE_SUPPRESSION_LIST = 'delete the suppression list ';

// Resend options list for Bulk Email Summary
export const  RESENDTOOPTIONS = [
        { value: '1', label: 'All recipients' },
        { value: '2', label: 'Unopened recipients' }
    ];

export const BULKCAMPAIGNSUCCESS  ='Bulk email scheduled successfully';
export const ACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign activated successfully';
export const DEACTIVATE_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign deactivated successfully';
export const DELETE_BULK_CAMPAIGN = 'delete the bulk campaign ';
export const COPY_BULK_CAMPAIGN = 'duplicate the bulk campaign ';
export const CANCEL_BULK_CAMPAIGN = 'cancel the bulk campaign ';
export const UPDATE_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Email updated successfully';
export const DELETE_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign deleted successfully';
export const COPY_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign duplicated successfully';
export const CHOOSE_SEEDLIST_MESSAGE ='Choose a seed list from the dropdown. Emails from the selected seed list will be prepended to the original imported CSV file. This means emails will be sent to both the imported recipients and the seed list recipients.';
export const CHOOSE_SUPPRESSIONLIST_MESSAGE ='Choose a suppression list from the dropdown. Emails from the selected list will be excluded from the originally imported CSV file. Any recipient included in the suppression list will not receive emails.';
export const BULKCAMPAIGN_RESEND_DATE_MESSAGE ='Add a resend date and time. This schedule will be used to resend emails to the same recipient. This is an optional field, and you can add more than one resend date and time if needed.';
export const BULK_CAMPAIGN_NAME_TOOLTIP_MESSAGE = "An internal name used to identify the bulk email.";
export const RESUME_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign resume successfully';
export const PAUSE_BULK_CAMPAIGN_SUCCESS_MESSAGE = 'Bulk Campaign pause successfully';
export const BULK_CAMPAIGN_CANCEL_SUCCESS_MESSAGE = 'Bulk Campaign cancelled successfully';
export const BULK_CLIENT_CAMPAIGN_ID = 'The custom Campaign ID can be provided by the client.';

// Unsubscribe levels for campaign
export const  UNSUBSCRIBE_LEVELS = [
        { value: '1', label: 'Global' },
        { value: '2', label: 'Client' },
        { value: '3', label: 'Campaign' },
        { value: '4', label: 'Brand' }
];

// priority options for bulk campaign
export const  PRIORITY_OPTIONS = [
        { value: '1', label: 'Low' },
        { value: '2', label: 'Normal' },
        { value: '3', label: 'High' }
];

// Unsubscribe levels for bulk campaign
export const  BULK_UNSUBSCRIBE_LEVELS = [
        { value: '1', label: 'Global' },
        { value: '2', label: 'Client' },
        { value: '3', label: 'Campaign' },
];
// Bounce Report
export const BOUNCEREPORT_CAMPAIGN_DISABLED_MESSAGE = "Please choose campaign type";

// UnsubscribeEmail
export const UNSUBSCRIBE_EMAIL_SUCCESS = "Email removed successfully";
export const UNSUBSCRIBE_EMAIL_FAILURE = "Failed to remove email";